import { useCallback } from 'react'
import { FC } from 'react'
import { connect } from 'react-redux'
import * as styles from 'components/features/pfm/NotificationTray/NotificationTray.css'
import { InsightNotification } from 'interfaces/notifications'
import Shownable from 'components/utils/Shownable'
import Icon from 'components/atoms/Icon'
import InsightFooter from 'components/features/insights/InsightFooter/InsightFooterContainer'
import { insightShownActionCreator } from 'actions/insightsActions'

type InsightNotificationItemOwnProps = {
  notification: InsightNotification
  // shouldn't send shown when animating
  isAnimating: boolean
}

type InsightNotificationItemDispatchProps = {
  onInsightShown: typeof insightShownActionCreator
}

type InsightNotificationItemProps = InsightNotificationItemDispatchProps & InsightNotificationItemOwnProps

const InsightNotificationItemComponent: FC<InsightNotificationItemProps> = (props) => {
  const {
    notification,
    onInsightShown,
    isAnimating,
  } = props
  const { insight, icon, text } = notification
  const isFakeId = insight.id < 0
  const isShownEnabled = (!isAnimating || notification.showMode !== 'regular') && !isFakeId

  const handleShown = useCallback(
    () => onInsightShown(insight),
    [insight, onInsightShown],
  )

  return (
    <Shownable
      data-slug={ insight.slug }
      isShownEnabled={ isShownEnabled }
      onShown={ handleShown }
    >
      <div className={ styles.itemInner }>
        { icon && (
          <div className={ styles.icon }>
            <Icon kind={ icon } />
          </div>
        )}
        <section className={ styles.itemContent }>
          <section className={ styles.itemText }>
            { text }
          </section>
          <div className={ styles.buttons }>
            <InsightFooter insight={ insight } />
          </div>
        </section>
      </div>
    </Shownable>
  )
}

const mapDispatchToProps: InsightNotificationItemDispatchProps = {
  onInsightShown: insightShownActionCreator,
}

export const InsightNotificationItem = connect<
  {},
  InsightNotificationItemDispatchProps,
  InsightNotificationItemOwnProps
>(undefined, mapDispatchToProps)(InsightNotificationItemComponent)
